    import React from 'react';
    import '../../styles/mfw.scss';
    import { Link } from 'react-router-dom';
    
function Mfwsemptember() {
  const immagini = [
    { image: '/images/MFW2023/MFW2023_3.jpg', title: ["ELENA HAZINAH X Tiktok Event"], className: "" },
    { image: '/images/MFW2023/MFW2023_5.jpg', title: ["ELENA HAZINAH X ANNAKIKI Fashion Show"], className: ""  },
    { image: '/images/MFW2023/MFW2023_2.jpg', title: ["ELENA HAZINAH X Tiktok Event"], className: "" },
    { image: '/images/MFW2023/MFW2023_4.jpg', title: ["ELENA HAZINAH X SARA WONG Fashion Show"], className: ""  },
    { image: '/images/MFW2023/MFW2023_1.jpg', title: ["ELENA HAZINAH X GIUSEPPE ZANOTTI Event"], className: ""},
  ];
  return (
    <section className="magazine">
      <div className="image-grid">
        {immagini.map((img, index) => (
          <div key={index} className={`image-grid__item ${img.className}`}>
            <Link to={img.link}>
              <img src={img.image} alt={img.title.join(' ')} />
              <h3 className="image-grid__title">
                {img.title.map((line, i) => (
                  <span key={i}>
                    {line}
                    {i < img.title.length - 1 && <br />}
                  </span>
                ))}
              </h3>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Mfwsemptember;
